import type React from 'react';

export function Stat({
  icon: Icon,
  label,
  value,
}: {
  icon: React.FC<{ className?: string }>;
  label: string;
  value: string;
}) {
  return (
    <div className="flex items-center gap-2 text-sm">
      <Icon className="h-4 w-4 text-muted-foreground" aria-hidden="true" />
      <span className="text-muted-foreground">{label}:</span>
      <span className="font-medium">{value}</span>
    </div>
  );
}

export function Counts({
  label,
  items,
  severity,
}: {
  label: string;
  items: unknown[];
  severity: 'block' | 'warn';
}) {
  const tone =
    severity === 'block'
      ? 'border-red-300 bg-red-50 text-red-800 dark:border-red-700 dark:bg-red-950/30 dark:text-red-300'
      : 'border-amber-300 bg-amber-50 text-amber-800 dark:border-amber-700 dark:bg-amber-950/30 dark:text-amber-300';
  return (
    <div className={`rounded border p-3 text-sm ${tone}`}>
      <p className="font-medium">
        {label}: {items.length}
      </p>
      {items.length > 0 && (
        <ul className="mt-1 list-disc list-inside text-xs">
          {items.slice(0, 5).map((it, i) => {
            const obj = (it as Record<string, unknown> | null) ?? {};
            const msg = typeof obj.message === 'string' ? obj.message : JSON.stringify(it);
            return <li key={i}>{msg}</li>;
          })}
          {items.length > 5 && <li className="opacity-70">… and {items.length - 5} more</li>}
        </ul>
      )}
    </div>
  );
}
